import { useFormat } from '@ideavivat/vivat-2';

const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    name: {
      name: 'ชื่อประเภท',
      width: '1fr',
    },
    productCount: {
      name: 'จำนวนสินค้า',
      width: '6rem',
      class: 'text-right mr-2',
    },
    updatedAt: {
      name: 'เคลื่อนไหวล่าสุด',
      width: '14rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
  },
  sortable: [
  ],
};
